/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import Checkbox from '../../components/checkbox';
import CheckboxTree from '../../components/checkbox-tree';
import DatePicker from '../../components/datepicker';
import FormItemWrapper from '../../components/form-item-wrapper';
import HtmlEditor from '../../components/html-editor';
import Input from '../../components/input';
import LayoutItemWrapper from '../../components/layout-item-wrapper';
import Radios from '../../components/radios';
import Select from '../../components/select';
import Table from '../../components/table';
import Textarea from '../../components/textarea';
import Uploader from '../../components/uploader';
import { LayoutContext } from '../../contexts/layout';
import { formModeSelector } from '../../redux/selectors/forms';
import { TFormFieldLayout } from '../../types/layout/form';

interface IFormItemsFactoryProps {
    fields: TFormFieldLayout[];
}

function FormItemsFactory({ fields }: IFormItemsFactoryProps) {
    const { layoutId } = useContext(LayoutContext);

    const formMode = useSelector(formModeSelector(layoutId));

    const renderFormItem = (field: TFormFieldLayout) => {
        switch (field.type) {
            case 'input': {
                return (
                    <Input {...field} />
                );
            }
            case 'textarea': {
                return (
                    <Textarea {...field} />
                );
            }
            case 'datepicker':
            case 'datepicker-range': {
                return (
                    // @ts-ignore
                    <DatePicker {...field} />
                );
            }
            case 'select':
            case 'multiple-select': {
                return (
                    // @ts-ignore
                    <Select {...field} />
                );
            }
            case 'uploader': {
                return (
                    // @ts-ignore
                    <Uploader {...field} />
                );
            }
            case 'html-editor': {
                return (
                    // @ts-ignore
                    <HtmlEditor {...field} />
                );
            }
            case 'table': {
                return React.createElement(Table, field);
            }
            case 'checkbox': {
                return (
                    // @ts-ignore
                    <Checkbox {...field} />
                );
            }
            case 'checkbox-tree': {
                return (
                    // @ts-ignore
                    <CheckboxTree {...field} />
                );
            }
            case 'radios': {
                return (
                    // @ts-ignore
                    <Radios {...field} />
                );
            }
            default: {
                return null;
            }
        }
    };

    const renderFormItems = () => React.Children.toArray(fields.map((field) => (
        <LayoutItemWrapper breakpointColumn={field.breakpointColumn} dependingFieldsValues={field.dependingFieldsValues}>
            <FormItemWrapper
                fieldName={field.dataIndex}
                formMode={formMode}
                validation={field.validation}
                fieldTitle={field.title}
                onValueChangeAction={field.onValueChangeAction}
                layout={field}
            >
                {renderFormItem(field)}
            </FormItemWrapper>
        </LayoutItemWrapper>
    )));

    return (
        <>
            {renderFormItems()}
        </>
    );
}

export default FormItemsFactory;
